"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SvgSoc2 = function SvgSoc2(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.11a4 4 0 0 1-2.52-.9l-15-13.01A4 4 0 0 1 5 30.1L4 6.28a4 4 0 0 1 3.23-3.93C15.26.78 20.85 0 24 0v47.11Z",
    fill: "#A0DB77"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.11V0c2.24 0 14.46 1.9 16.77 2.35A4 4 0 0 1 44 6.28L43 30.1a4 4 0 0 1-1.48 3.1l-15 13.01a4 4 0 0 1-2.52.9Z",
    fill: "#AAD895"
  }), /*#__PURE__*/React.createElement("rect", {
    y: "11",
    width: "48",
    height: "16",
    rx: "2",
    fill: "#61C1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 23.1c-.64 0-1.25-.08-1.84-.24a4.46 4.46 0 0 1-1.48-.72l.6-1.34a4.7 4.7 0 0 0 2.75.86c.53 0 .93-.09 1.21-.26.29-.17.43-.41.43-.72 0-.27-.13-.48-.4-.63a5.1 5.1 0 0 0-1.37-.45 7.8 7.8 0 0 1-1.8-.55 2.4 2.4 0 0 1-.96-.79c-.2-.32-.3-.71-.3-1.18 0-.5.14-.96.42-1.36.28-.4.68-.72 1.2-.94.5-.23 1.1-.35 1.77-.35.6 0 1.18.09 1.73.27.56.17 1 .4 1.33.7l-.6 1.34a4.08 4.08 0 0 0-2.45-.86c-.48 0-.87.1-1.15.3a.87.87 0 0 0-.42.76c0 .2.05.35.16.48.11.12.29.23.54.32.25.1.61.2 1.08.3a5.9 5.9 0 0 1 2.34.93c.48.37.72.9.72 1.56 0 .8-.31 1.43-.93 1.9-.61.45-1.47.68-2.58.68ZM18.54 23.1a4.4 4.4 0 0 1-2.2-.52 3.67 3.67 0 0 1-1.42-1.51 4.99 4.99 0 0 1-.5-2.3c0-.89.16-1.65.5-2.3.34-.65.81-1.16 1.43-1.51a4.4 4.4 0 0 1 2.2-.53c.83 0 1.56.18 2.18.53.62.35 1.1.86 1.44 1.51.33.65.5 1.41.5 2.3 0 .87-.17 1.64-.5 2.3a3.65 3.65 0 0 1-1.44 1.51c-.62.35-1.35.53-2.19.53Zm0-1.44c.7 0 1.26-.25 1.66-.75.4-.5.61-1.21.61-2.15 0-.93-.2-1.64-.6-2.13-.4-.5-.95-.75-1.67-.75-.7 0-1.26.25-1.66.75-.4.49-.6 1.2-.6 2.13 0 .94.2 1.66.6 2.15.4.5.96.75 1.66.75ZM28.07 23.1a4.5 4.5 0 0 1-2.24-.53 3.68 3.68 0 0 1-1.46-1.53 4.93 4.93 0 0 1-.5-2.28c0-.86.16-1.62.5-2.28a3.6 3.6 0 0 1 1.46-1.5 4.91 4.91 0 0 1 3.85-.28c.51.16.93.4 1.26.7l-.6 1.34a4.01 4.01 0 0 0-1.1-.62c-.36-.12-.74-.19-1.13-.19-.75 0-1.33.24-1.74.72-.4.48-.6 1.19-.6 2.11 0 .93.2 1.64.6 2.13.4.48.99.72 1.74.72.4 0 .77-.07 1.13-.2.37-.12.73-.33 1.1-.6l.6 1.33c-.33.3-.75.54-1.26.72-.51.16-1.05.25-1.6.25ZM41.36 21.5V23h-5.82v-1.38l2.82-2.99c.59-.62.89-1.2.89-1.73 0-.67-.39-1-1.16-1-.35 0-.72.07-1.1.21-.38.14-.76.34-1.13.6l-.59-1.33a5.1 5.1 0 0 1 2.92-.95c.88 0 1.58.21 2.1.64.53.42.8.99.8 1.7 0 .49-.11.94-.32 1.36-.2.41-.54.88-1.02 1.39l-1.88 1.98h3.49Z",
    fill: "#fff"
  }));
};

var _default = SvgSoc2;
exports["default"] = _default;